/**
 * transitions.js — Cross-Document View Transitions (Lenis Integration)
 *
 * The transition itself is purely CSS-driven (@view-transition in
 * transitions.css). This module only handles the Lenis smooth-scroll
 * lifecycle during page swaps:
 *
 *   pageswap (old page) → destroy Lenis so its RAF loop doesn't shift
 *     the scroll position while the browser captures the exit snapshot.
 *
 * The new page's Lenis re-initialises automatically from main.js on
 * DOMContentLoaded — no special handling needed on the incoming side.
 */

import { getLenis } from "./lenis.js";

/**
 * Register lifecycle hooks for view transitions.
 * Only runs setup if the browser supports MPA view transitions
 * (the pageswap event only fires in supporting browsers).
 */
export function initTransitions() {
  window.addEventListener("pageswap", () => {
    const lenis = getLenis();
    if (lenis) {
      lenis.destroy();
      window.lenis = null;
    }
  });
}
